import { adminUsersApi } from 'features/admin/features/users/service/adminUsersApi';
import { adminFeedbackApi } from 'features/admin/features/feedback/service/adminFeedbackApi';
import { adminPaymentsApi } from 'features/admin/features/payments/service/adminPaymentsApi';
import { adminCommunitiesApi } from 'features/admin/features/communities/service/adminCommunitiesApi';
import { adminShopDetailsApi } from 'features/admin/features/shop-details/service/adminShopDetailsApi';

export const adminApi = [
    adminUsersApi.middleware,
    adminFeedbackApi.middleware,
    adminPaymentsApi.middleware,
    adminCommunitiesApi.middleware,
    adminShopDetailsApi.middleware,
];

export const adminReducers = {
    [adminUsersApi.reducerPath]: adminUsersApi.reducer,
    [adminFeedbackApi.reducerPath]: adminFeedbackApi.reducer,
    [adminPaymentsApi.reducerPath]: adminPaymentsApi.reducer,
    [adminCommunitiesApi.reducerPath]: adminCommunitiesApi.reducer,
    [adminShopDetailsApi.reducerPath]: adminShopDetailsApi.reducer,
};
